import React, { useMemo, useState } from "react"
import Heading from "../common/heading/Heading"
import "./Branch.css"
import {  locationPhotos } from "../../dummydata"
import LocationModal from "./LocationModal"

const Branch = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const branchDirectory = useMemo(() => ([
    { name: "Kandy", lookup: "Kandy", phones: ["076 999 8889", "072 260 4477", "072 928 3616"] },
    { name: "Gampaha", lookup: "Gampaha", phones: ["070 208 9999"] },
    { name: "Rajarata", lookup: "Anuradhapura", phones: ["070 164 3884", "072 690 8792"] },
    { name: "Ratnapura", lookup: "Ratnapura", phones: ["070 490 7312", "076 690 5379"] },
    { name: "Bandarawela", lookup: "Bandarawela", phones: ["070 372 2490", "074 098 1303"] },
    { name: "Kurunegala", lookup: "Kurunegala", phones: ["072 069 7076 "] },
    { name: "Polonnaruwa", lookup: "Polonnaruwa", phones: ["075 333 8900"] },
    { name: "Kalutara", lookup: "Kalutara", phones: ["074 000 4970" ,"074 000 4978 "] },
    { name: "Matara", lookup: "Matara", phones: ["076 909 9249 "] },
    { name: "Colombo", lookup: "Nugegoda", phones: ["072 260 4470 ", "070 760 4470"] },
    { name: "Kegalle", lookup: "Kegalle", phones: ["070 513 9244","076 822 4101 "] },
    { name: "Nuwara Eliya", lookup: "Nuwara Eliya", phones: ["076 999 8889 ", "072 260 4477","072 928 3616 "] },
    { name: "Jaffna", lookup: "Jaffna", phones: [] },
    { name: "Vavuniya", lookup: "Vavuniya", phones: [] }
  ]), []);

  const getLocationMatch = (branch) =>
    locationPhotos.find((loc) =>
      loc.name.toLowerCase().includes(branch.lookup.toLowerCase())
    );

  const handleLearnMore = (location) => {
    setSelectedLocation(location);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLocation(null);
  };

  const sanitizeTel = (value) => value.replace(/\s+/g, "");

  return (
    <>
      <section className='homeAbout'>
        <div className='container'>
         

          <div className='branch-directory'>
            <div className='branch-directory-header'>
              <Heading subtitle='Branch' title='Branch Contact Directory' />
              <p>Reach out to the nearest SDTI branch using the dedicated contact numbers below.</p>
            </div>
            <div className='branch-directory-grid'>
              {branchDirectory.map((branch) => {
                const location = getLocationMatch(branch);
                const phonesAvailable = branch.phones.length > 0;
                return (
                  <div className='branch-card' key={branch.name}>
                    <div className='branch-card-media'>
                      {location ? (
                        <img
                          src={location.image}
                          alt={`${branch.name} branch`}
                        />
                      ) : (
                        <div className='branch-card-placeholder'>
                          {branch.name.charAt(0)}
                        </div>
                      )}
                    </div>
                    <div className='branch-card-body'>
                      <h3>{branch.name}</h3>
                      <p className='branch-card-desc'>
                        {location?.description || "Details will be published soon."}
                      </p>
                      <div className='branch-card-phones'>
                        {phonesAvailable ? (
                          branch.phones.map((phone) => (
                            <a key={phone} href={`tel:${sanitizeTel(phone)}`}>
                              <i className='fas fa-phone'></i>
                              {phone}
                            </a>
                          ))
                        ) : (
                          <span className='coming-soon'>Contact number coming soon</span>
                        )}
                      </div>
                      <button
                        className='visit-button secondary'
                        onClick={() => location && handleLearnMore(location)}
                        disabled={!location}
                      >
                        {location ? "View Branch Details" : "Details Coming Soon"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* <OnlineCourses /> */}
      </section>

      {/* Location Modal */}
      <LocationModal 
        isOpen={isModalOpen}
        onClose={closeModal}
        location={selectedLocation}
      />
    </>
  )
}

export default Branch
